export function ServiceSkeletonCard() {
  return (
    <div className="flex flex-col rounded-xl border border-border/50 bg-card p-4 shadow-sm sm:p-5">
      <div className="mb-3 flex items-start justify-between">
        <div className="size-10 animate-pulse rounded-lg bg-muted" />
        <div className="h-5 w-16 animate-pulse rounded-full bg-muted" />
      </div>
      <div className="h-5 w-3/4 animate-pulse rounded bg-muted" />
      <div className="mt-2 h-4 w-full animate-pulse rounded bg-muted/60" />
      <div className="mt-1 h-4 w-2/3 animate-pulse rounded bg-muted/60" />
      <div className="mt-4 flex gap-4">
        <div className="h-4 w-16 animate-pulse rounded bg-muted/40" />
        <div className="h-4 w-16 animate-pulse rounded bg-muted/40" />
      </div>
    </div>
  );
}
